<template>
  <bulk-update-wrapper
    :saving="saving"
    title="Mark as Cancelled"
    :button-label="buttonLabel"
    :has-changes="true"
    @save="save"
    @dismiss="dismiss"
  >
    <vs-text> Warning, cancelling jobs cannot be reversed</vs-text>

    <template #error-snackbar>
      <vs-snackbar :value="error" type="error" sticky @input="clearSnackbar">
        Failed to cancel jobs
      </vs-snackbar>
    </template>
  </bulk-update-wrapper>
</template>

<script setup lang="ts">
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import { ref, computed } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { bulkCancel } from '@/api/jobs'

const emits = defineEmits<{
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}>()

const props = defineProps<{
  selectedJobs: JobJson[]
}>()

const error = ref(false)
const saving = ref(false)

const dismiss = () => emits('dismiss')
const clearSnackbar = () => (error.value = false)

const buttonLabel = computed<string>(() => {
  const jobCount = props.selectedJobs.length
  return jobCount >= 2 ? `Cancel ${jobCount} jobs` : 'Cancel job'
})

const save = async () => {
  saving.value = true
  try {
    await bulkCancel(props.selectedJobs.map((job) => job.number))
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, { status: 'Cancelled' }),
    )
    emits('updated', { message: 'Jobs cancelled', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
</script>
